import {
  Briefcase, Users, Compass, Layers, Sparkles, ShieldCheck, Rocket, Search,
} from "lucide-react";
import AudiencePageShell from "../components/AudiencePageShell";
import SeoHead from "../components/SeoHead";

export default function PourLesEmployeurs() {
  return (
    <>
    <SeoHead
      title="Pour les employeurs · Recrutez les meilleurs talents africains"
      description="Accédez à un vivier panafricain de talents vérifiés — numérique, BTP, santé, agriculture, industrie. AFRICTAL accélère vos recrutements avec un matching IA, un Passeport Numérique certifié et un séquestre sécurisé."
      path="/pour-les-employeurs"
      keywords="recrutement Afrique, employeurs, talents vérifiés, matching IA, offres emploi, freelances certifiés"
    />
    <AudiencePageShell
      testIdRoot="afr-audience-employeurs"
      breadcrumb={{ label: "Employeurs" }}
      eyebrow="Pour les employeurs"
      accentColor="var(--mod-emploi)"
      heroTitle={<>Trouvez les compétences <em>dont votre entreprise a besoin.</em></>}
      heroText={
        "Que vous soyez une entreprise, une PME, une administration, une association ou un porteur de projet, AFRICTAL vous aide à recruter les bons profils, trouver des freelances et constituer des équipes performantes pour concrétiser vos projets."
      }
      ctaPrimary={{ label: "Publier une offre", to: "/login?mode=signup&role=employeur", icon: Briefcase }}
      ctaSecondary={{ label: "Trouver des talents", to: "/login?mode=signup&role=employeur" }}

      servicesTitle="Les solutions pour les employeurs"
      servicesLead="Recrutez, collaborez et développez vos équipes à l'échelle panafricaine."
      services={[
        { icon: Briefcase,   title: "Publier des offres d'emploi",         desc: "Diffusez vos besoins auprès d'un vivier de talents africains qualifiés." },
        { icon: Search,      title: "Rechercher des talents qualifiés",    desc: "Explorez notre annuaire filtrable par compétences, localisation et expérience." },
        { icon: Compass,     title: "Trouver des freelances",              desc: "Missions ponctuelles ou longues — accès à des freelances vérifiés dans tous les secteurs." },
        { icon: Layers,      title: "Constituer une équipe projet",        desc: "Assemblez rapidement des profils complémentaires pour lancer vos projets." },
        { icon: Users,       title: "Collaborer avec des experts",         desc: "Consultez, échangez et co-construisez avec des experts métiers de haut niveau." },
        { icon: Sparkles,    title: "Être accompagné dans vos recrutements", desc: "L'Orchestrateur IA d'AFRICTAL vous guide dans la définition de vos besoins et la sélection." },
      ]}

      stepsTitle="Comment ça fonctionne"
      steps={[
        "Créer un compte",
        "Publier une offre ou décrire votre besoin",
        "Découvrir les talents recommandés",
        "Échanger avec les candidats",
        "Recruter et collaborer",
      ]}

      whyTitle="Un réseau de talents panafricains dans tous les secteurs"
      whyText={
        "AFRICTAL permet aux employeurs d'accéder à un réseau de talents africains dans tous les secteurs — numérique, BTP, santé, agriculture, industrie, télécommunications, énergie, artisanat, et bien d'autres. Notre mise en relation intelligente accélère vos recrutements en identifiant précisément les compétences qui correspondent à vos besoins."
      }

      ctaFinalTitle="Les meilleures compétences existent déjà. AFRICTAL vous aide à les trouver."
      ctaFinalPrimary={{ label: "Publier une offre", to: "/login?mode=signup&role=employeur", icon: Briefcase }}
      ctaFinalSecondary={{ label: "Créer un compte", to: "/login?mode=signup&role=employeur" }}
    />
    </>
  );
}
